import { render, staticRenderFns } from "./ProductsCreateEditModal.vue?vue&type=template&id=2b4a19c3&scoped=true&"
import script from "./ProductsCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./ProductsCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a19c3",
  null
  
)

export default component.exports